import React,{useState}from 'react'
import './contact.css'
import { MdOutlineEmail } from 'react-icons/md'
import { BsWhatsapp } from 'react-icons/bs'
import { RiMessengerLine } from 'react-icons/ri'
import { useRef } from 'react';
import emailjs from 'emailjs-com';
import facebook from '../assets/facebook.png'
import twitter from '../assets/twitter.png'
import linkedin from '../assets/linkedin.png'

const Contact = () => {
  const formRef = useRef();
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm({ ...form, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);


    emailjs
      .send(
        process.env.REACT_APP_EMAIL_SERVICE_ID,
        process.env.REACT_APP_EMAIL_TEMPLATE_ID, 
        {
          from_name: form.name,
          to_name: "Ushindi Gedeon", 
          from_email: form.email,
          to_email: "gedeontshobohwa1@gmail.com", 
          message: form.message,
        },
        process.env.REACT_APP_EMAIL_PUBLIC_KEY 
      )
      .then(
        () => {
          setLoading(false);
          alert("Thank you. We will get back to you as soon as possible.");

          setForm({
            name: "",
            email: "",
            message: "",
          });
        },
        (error) => {
          setLoading(false);
          console.log(error);
          alert("Something went wrong. Please try again.");
        }
      );
  };

  return (
    <section id="Contact">
      <h5>Get in Touch</h5>
      <div className='container contact__container'>
        <div className='contact__options'>
          <div className='contact__option__mobile'>
            <ul className='nav-socials-mobile'>
              <li><a href="#"><img src={linkedin} alt="linkedIn Icon" /></a></li>
              <li><a href="#"><img src={twitter} alt="twitter Icon" /></a></li>
              <li><a href="#"><img src={facebook} alt="facebook Icon" /></a></li>
            </ul>
          </div>
          <article className='contact__option'>
            <MdOutlineEmail className='contact__option-icon' />
            <h4>Email</h4>
            <a href='mailto:gedeontshobohwa1@gmail.com' target='_blank'>Send a message</a>

          </article>
          <article className='contact__option'>
            <RiMessengerLine className='contact__option-icon' />
            <h4>Messenger</h4>
            <a href='https://m.me/gedeon.tshobohwa' target='_blank'>Send a message</a>

          </article>
          <article className='contact__option'>
            <BsWhatsapp className='contact__option-icon' />
            <h4>Whatsapp</h4>
            <a href='https://api.whatsapp.com/send?phone=+250780458297' target='_blank'>Send a message</a>
          </article>

        </div>
        {/*END OF CONTACT OPTIONS*/}
        <form ref={formRef} onSubmit={handleSubmit}>
          <input type="text" name='name' placeholder='Your Full Name' onChange={handleChange} required />
          <input type="email" name='email' placeholder='Your email' onChange={handleChange} required />
          <textarea name='message' rows='7' placeholder='Your message' onChange={handleChange} required />
          <button type='submit' className='btn btn-primary'>
            {loading ? "Sending..." : "Send message"}
            </button>
        </form>
      </div>

    </section>
  )
}

export default Contact